import { Navigate, Route, Routes } from "react-router-dom"
import { TelegramProvider } from "./context/TelegramContext";
import { CardProvider } from "./context/CardContext";
import { LoadingProvider } from "./context/LoadingContext";
import { OnboardingProvider } from "./context/OnboardingContext";
import OnboardingEntry from "./pages/onboarding/OnboardingEntry";
import TarrifPage from "./pages/onboarding/TarrifPage";
import OfferPage from "./pages/onboarding/OfferPage";
import PaymentPage from "./pages/onboarding/PaymentPage";
import SuccessPage from "./pages/onboarding/SuccessPage";
import DashboardPage from "./pages/onboarding/DashboardPage";
import HistoryPage from "./pages/onboarding/HistoryPage";
import BlockedPage from "./pages/onboarding/BlockedPage";
// import VerifyForm from "./pages/add-card/VerifyForm";
// import { useVerification } from "./hooks/useVerification";

export const App = () => {

    return (
        <LoadingProvider>
            <TelegramProvider>
                <OnboardingProvider>
                    <CardProvider>
                        <Routes>
                            <Route path='*' element={<Navigate to={'/1/onboarding'} />} />
                            <Route path="/:bot_id/onboarding" element={<OnboardingEntry />} />
                            <Route path="/:bot_id/onboarding/tariff" element={<TarrifPage />} />
                            <Route path="/:bot_id/onboarding/offer" element={<OfferPage />} />
                            <Route path="/:bot_id/onboarding/payment" element={<PaymentPage />} />
                            <Route path="/:bot_id/onboarding/success" element={<SuccessPage />} />
                            <Route path="/:bot_id/onboarding/dashboard" element={<DashboardPage />} />
                            <Route path="/:bot_id/onboarding/history" element={<HistoryPage />} />
                            <Route path="/:bot_id/onboarding/blocked" element={<BlockedPage />} />
                            <Route path="/:bot_id/card/add-card" element={<PaymentPage />} />
                            <Route path="/:bot_id/card/change" element={<PaymentPage replaceMode />} />
                        </Routes>
                    </CardProvider>
                </OnboardingProvider>
            </TelegramProvider>
        </LoadingProvider>
    )
}